export enum ProjectProtocolId {
    Rest = 'rest',
    Graphql = 'graphql',
    Websocket = 'websocket',
}
